import { RefObject, useLayoutEffect, useState } from 'react'

/** Move one mounted composer between the discussion and fullscreen, preserving uploads and dictation. */
export function useCommentComposerPortal(
  dock: RefObject<HTMLDivElement>,
  target: HTMLDivElement | null | undefined,
  enabled: boolean
) {
  const [host] = useState(() => document.createElement('div'))

  useLayoutEffect(() => {
    if (!enabled) return
    const destination = target || dock.current
    destination?.appendChild(host)
    return () => host.remove()
  }, [dock, enabled, host, target])

  return enabled ? host : null
}
